import React, { forwardRef, useImperativeHandle } from 'react';
import { Form } from 'react-bootstrap';
import '../sharedFormControl.css';

const Website = forwardRef((props, ref) => {
    const [isInvalid, setIsInvalid] = React.useState(false);

    useImperativeHandle(ref, () => ({ isInvalid }), [isInvalid]);

    const pattern = new RegExp("^(https?:\\/\\/)?(www\\.)?[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*(\\.[a-zA-Z]{2,})(\\/[^\s]*)?$");

    const onChange = (val) => {
        if (val?.trim() !== '') {
            const isValid = pattern.test(val);
            setIsInvalid(!isValid);
        } else {
            setIsInvalid(false); 
        }

        if (props.onChange) {
            props.onChange(props.objectKey, val);
        }
    };

    return (
        <React.Fragment>
            <fieldset className='default-fieldset'>
                {!props.hideLegend && (
                    <legend className='default-fieldset-label'>
                        {props.label || ''}
                    </legend>
                )}
                <Form.Control
                    type="text"
                    required={props.required}
                    name={props.objectKey}
                    placeholder={props.placeholder}
                    disabled={props.disabled}
                    value={props.value}
                    onChange={(event) => onChange(event.target.value)}
                    style={props.style || {}}
                    isInvalid={isInvalid}
                />
            </fieldset>
            <Form.Control.Feedback type="invalid">
                {props.errorMessage || `Please enter a valid ${props.name}.`}
            </Form.Control.Feedback>

            {isInvalid && (
                <span className='input-error-message'>
                    {props.errorMessage || `Please enter a valid ${props.name}.`}
                </span>
            )}
        </React.Fragment>
    );
});

export default Website;
